import parser from 'ua-parser-js'

export enum BrowserName {
  MOBILE_SAFARI = 'Mobile Safari',
  SAFARI = 'Safari',
}

export const getUserBrowser = () => {
  const ua = parser(navigator.userAgent)
  return { browserName: ua.browser.name, browserVersion: ua.browser.version }
}

export const getOSDetails = () => {
  const ua = parser(navigator.userAgent)
  return { osVersion: ua.os.version, osName: ua.os.name }
}

export const getIsAndroid = () => {
  const ua = parser(navigator.userAgent)
  return (ua.os.name || '').toLowerCase().includes('android')
}
